// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3cJe2","notes":"Notes_notes__vlL3N"};